<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false"
             :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()"
             :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
      <el-form-item label="模版标题" prop="templateTitle">
        <el-input v-model="dataForm.templateTitle" placeholder="模版标题"></el-input>
      </el-form-item>
      <el-form-item label="模版类型" prop="templateType">
        <el-select v-model="dataForm.templateType" placeholder="请选择">
          <el-option label="短信" :value="messageType.SMS" ></el-option>
          <el-option label="微信" :value="messageType.WE_CHAT"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="模版ID" prop="templateId">
        <el-input v-model="dataForm.templateId" placeholder="微信模版ID或短信模版ID"></el-input>
      </el-form-item>
      <el-form-item label="学校" prop="schoolId" v-if="schoolVisible">
        <el-select v-model="dataForm.schoolId" placeholder="请选择学校" clearable filterable>
          <el-option v-for="school in schoolList" :label="school.schoolName" :value="school.id"
                     :key="school.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="键与表述" prop="keyExplain">
        <div v-for="(keyExplain,index) in keyExplains" class="keyExplain">
          <div>
            <el-input placeholder="键" v-model="keyExplain['key']" >
            </el-input>
          </div>
          <div>
            <el-input placeholder="表述" v-model="keyExplain['explain']">
            </el-input>
          </div>
          <div style="justify-content: left">
            <el-button size="mini" type="danger" @click="keyExplainRemoveHandle(index)">移除</el-button>
          </div>
        </div>
        <el-button size="mini" type="primary" @click="keyExplainAddHandle()">添加</el-button>
      </el-form-item>
      <el-form-item label="示例" prop="example">
        <el-input v-model="dataForm.example" type="textarea" placeholder="示例"></el-input>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button type="primary" @click="quickFillForm()" v-if="!this.dataForm.id">快速填充模板数据</el-button>
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import { messageType } from '@/constant'
export default {
  data () {
    return {
      visible: false,
      schoolVisible: false,
      keyExplains: [],
      schoolList: [],
      messageType,
      dataForm: {
        id: '',
        deleted: '',
        templateTitle: '',
        templateType: '',
        keys: '',
        keyExplain: '',
        templateId: '',
        example: '',
        schoolId: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        id: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deleted: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        templateTitle: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        templateType: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        keys: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        templateId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        example: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        schoolId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.dataForm.resetFields()
        this.resetValue()
        this.keyExplains = []
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get('/message/template/' + this.dataForm.id).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
        if (this.dataForm.keyExplain) {
          this.keyExplains = JSON.parse(this.dataForm.keyExplain)
        }
      }).catch(() => {
      })
    },
    // 获取学校的集合
    getSchoolList () {
      this.$http.get('/school/school/getSchoolList').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.schoolList = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    resetValue () {
      this.dataForm.schoolId = ''
      this.schoolVisible = false
    },
    keyExplainAddHandle () {
      this.keyExplains.push({ explain: '', key: '' })
    },
    keyExplainRemoveHandle (index) {
      this.keyExplains.splice(index, 1)
    },
    // 快速填充键与表述
    quickFillForm () {
      this.dataForm.templateTitle = '班主任班级评价通知'
      this.dataForm.templateType = 1
      this.dataForm.templateId = ''
      this.keyExplains = []
      this.dataForm.keyExplain = '[{"explain":"头部","key":"first"},{"explain":"报告标题","key":"keyword1"},{"explain":"反馈内容","key":"keyword2"},{"explain":"反馈人员","key":"keyword3"},{"explain":"反馈时间","key":"keyword4"},{"explain":"备注","key":"remark"}]'
      this.keyExplains = JSON.parse(this.dataForm.keyExplain)
      this.dataForm.example = '你好，你的报告收到反馈。\n' +
              '报告标题：关于如何协调部门工作\n' +
              '反馈内容：符合实情'
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs.dataForm.validate((valid) => {
        if (!valid) {
          return false
        }
        // 1.提交前的处理
        // 1.1 keyExplains 是否为空
        // if (!this.keyExplains.length) {
        //   return this.$message.error('请填写键与表述')
        // }
        // 1.2 key中是否存在为空的项
        for (let i = 0; i < this.keyExplains.length; i++) {
          const key = this.keyExplains[i].key
          const explain = this.keyExplains[i].explain
          if (!key) {
            return this.$message.error(`第${i + 1}行键为空请填写`)
          }
          if (!explain) {
            return this.$message.error(`第${i + 1}行表述为空请填写`)
          }
        }
        // 1.3 提取出key
        const keys = []
        this.keyExplains.forEach((item) => {
          keys.push(item.key)
        })
        this.dataForm.keys = JSON.stringify(keys)
        this.dataForm.keyExplain = JSON.stringify(this.keyExplains)
        this.$http[!this.dataForm.id ? 'post' : 'put'](`/message/template/?schoolId=${this.dataForm.schoolId}`, this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            if (res.code === 10050) {
              this.schoolVisible = true
              this.getSchoolList()
            }
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {
        })
      })
    }, 1000, { leading: true, trailing: false })
  }
}
</script>
<style scoped lang="scss">
.keyExplain {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-around;

  div {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 20px;
  }
}
</style>
